import * as yup from 'yup';

const terminalModel = {
  mid: "",
  msisdn: "",
  tid : "",
  city : "",
  country : "",
  emailtid : "",
  deviceType : "",
  state : "",
  storeaddress : "",
  storename : "",
  name : ""
};

const terminalSchema = yup.object().shape({
  mid: yup.string()
      .required('Merchant Id is required.')
      .matches(/^[a-zA-Z0-9-]+$/, 'Invalid Merchant Id format.'),

  msisdn: yup.string()
    .required('Mobile number is required.')
    .matches(/^971[0-9]{9}$/, 'Mobile number must contain only numbers, start with 971 and be 12 digits long.'),

  tid: yup.string()
    .required('Terminal id is required.')
    .matches(/^[a-zA-Z0-9]{8}$/, 'Terminal id must be exactly 8 characters.'),

  name: yup.string()
    .max(15, 'Name can be at most 15 characters.')
    .matches(/^[a-zA-Z ]+$/, { message: 'Name can only contain alphabets.', excludeEmptyString: true }),

  city: yup.string()
    .optional()
    .notOneOf(['-1'], 'Please select a valid city.'),

  state: yup.string()
    .optional()
    .max(2, 'State can be at most 2 characters.'),

  country: yup.string()
    .optional()
    .max(2, 'Country can be at most 2 characters.'),

  storename: yup.string()
    .matches(/^[a-zA-Z0-9]+$/, { message: 'Store Name can only contain alphabets and numbers.', excludeEmptyString: true }),

  storeaddress: yup.string()
    .optional()
    .max(50, 'Store Address can be at most 50 characters.'),

  emailtid: yup.string()
    .optional()
    .email('Invalid email format.')
    .max(50, 'Email can be at most 50 characters.'),

  deviceType: yup.string()
    .required('Device type is required.')
    .notOneOf(['-1'], 'Please select a valid device type.')
});

export { terminalSchema, terminalModel };